export interface VersionInfo {
  latestEasyPayVersion: string;
  latestSoFiPamVersion: string;
  supportedEasyPayVersions: string[];
  updateToEasyPayVersion: string;
  message: MLMessage;
}

export interface MLMessage {
  dutch: string;
  french: string;
  german: string;
  english: string;
}

export const INIT_VERSIONINFO_STATE: VersionInfo = {
  latestEasyPayVersion: '',
  latestSoFiPamVersion: '',
  supportedEasyPayVersions: [],
  updateToEasyPayVersion: '',
  message: {
    dutch: '',
    french: '',
    german: '',
    english: '',
  },
};
